<template>
  <nav
    ref="characterSheetNavBar"
    class="navbar-expand-lg bb-navbar p-2 px-4"
  >
    <div class="d-flex align-items-end mb-2">
      <!-- LOGO -->
      <img src="/bbLogo64Blue.png" />
      <router-link
        class="navbar-brand px-3 mb-1"
        :to="{ name: 'campaignsView' }"
      >
        <span class="fw-lighter bb-app-heading">BATTLEBOARD</span>
        <!-- <span class="px-5" style="color: #737373"> {{ arena_name }}</span> -->
      </router-link>

      <div
        class="collapse navbar-collapse"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav ms-auto mt-2 align-items-end">
          <!--------------->
          <!-- username -->
          <!--------------->
          <span
            class="navbar-text me-3"
            style="color: grey"
            >{{ user_name }}</span
          >
          <!-- avatar -->
          <li class="nav-item me-3">
            <span
              class="d-inline-block"
              v-tooltip:bottom="versionLabel"
              tabindex="0"
            >
              <img
                v-bind:src="avatar_image"
                height="70"
                width="70"
                class="rounded-circle bb-img"
                alt="Avatar"
              />
            </span>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
// --------
// scripts
//---------
import { mapGetters } from 'vuex'
export default {
  name: 'CharacterNavbar',
  data() {
    return {
      arena_name: '',
      arena_slug: '',
    }
  },
  computed: {
    user_name() {
      const userProfile = this.getUserProfile()
      return userProfile?.user_name || ''
    },
    avatar_image() {
      const userProfile = this.getUserProfile()
      return userProfile?.avatar_image || ''
    },
    versionLabel() {
      return this.$store?.getters?.['combat/getVersion'] || ''
    },
  },
  //---------
  // methods
  //---------
  methods: {
    ...mapGetters('auth', {
      getUserProfile: 'getUserProfile',
      isAuthenticated: 'isAuthenticated',
    }),
    ...mapGetters('combat', {
      getCampaign: 'getCampaign',
    }),
    getCampaignHandler() {
      let campaign = this.getCampaign()
      if (!campaign) {
        this.arena_name = ''
        this.arena_slug = ''
        return
      }
      this.arena_name = campaign.name
      this.arena_slug = campaign.slug
    },
  },
  //---------
  // mounted
  //---------
  mounted() {
    this.getCampaignHandler()
  },
}
</script>
